import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=460133db&"
import script from "./PropertyCard.vue?vue&type=script&lang=js&"
export * from "./PropertyCard.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=460133db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports